module.exports = __webpack_public_path__ + "img/start_stream.4d0e67af.svg";